module.exports = __webpack_public_path__ + "static/media/health-and-disease-anxiety-large.3b6c75a4.png";